import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { VENDORS } from "./apiRoutes";

interface UseGetVendorListByCommunityIdProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getVendorListByCommunityId = async (communityId: string) =>
  await axiosAuth.get(`${VENDORS}/community/${communityId}/dropdown`);

const useGetVendorListByCommunityId = ({
  communityId,
  queryParams,
}: UseGetVendorListByCommunityIdProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["community-vendors"],
    queryFn: () => getVendorListByCommunityId(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetVendorListByCommunityId;
